import * as React from 'react';
import * as ReactDom from 'react-dom';
import { canHover } from 'utils';
import { reportIssue } from 'utils/Tracker';
import Label from './Label';
import Loop from './Loop';
import TrackPlayer from './TrackPlayer';

interface Props {
  loop: Loop;
  onSelect: (loop: Loop) => void;
  onLabelSelect?: (label: Label) => void;
}

enum ViewState {
  Normal = 'normal',
  Loading = 'loading',
  Playing = 'playing'
}

export class LoopOption extends React.Component<Props, { state: ViewState }> {
  state = { state: ViewState.Normal };
  player: TrackPlayer | null = null;
  playLoopTimeout = 0;
  updateRequest = 0;
  bar: HTMLElement;
  contentEl = React.createRef<HTMLDivElement>();
  barWidth = 0;

  componentDidMount() {
    if (this.contentEl.current) {
      this.barWidth = this.contentEl.current.getBoundingClientRect().width + 10;
    }
  }

  componentWillUnmount() {
    window.removeEventListener('mousemove', this.onMouseMove);
    clearTimeout(this.playLoopTimeout);
    this.disposePlayer();
  }

  mouseDidEnter = () => {
    if (this.state.state === ViewState.Normal) {
      this.playLoopTimeout = window.setTimeout(this.playMusic, 150);
      window.addEventListener('mousemove', this.onMouseMove);
    } else {
      reportIssue('On MouseEnter LoopView should have normal state');
    }
    this.setState({ state: ViewState.Loading });
  };
  mouseDidLeave = () => {
    clearTimeout(this.playLoopTimeout);
    window.removeEventListener('mousemove', this.onMouseMove);
    this.disposePlayer();
    this.setState({ state: ViewState.Normal });
  };
  onMouseMove = () => {
    clearTimeout(this.playLoopTimeout);
    this.playLoopTimeout = window.setTimeout(this.playMusic, 150);
  };
  playMusic = () => {
    window.removeEventListener('mousemove', this.onMouseMove);
    this.player = new TrackPlayer(this.props.loop.audio);
    this.update();
  };
  update = () => {
    if (this.state.state === ViewState.Loading && this.player!.isLoaded) {
      this.bar = (ReactDom.findDOMNode(this) as HTMLElement).querySelector(
        '.text .bar'
      ) as HTMLElement;
      // this.bar.style.left = '50px';
      this.setState({ state: ViewState.Playing }, () => {
        this.update();
      });
      return;
    }

    if (this.state.state === ViewState.Playing) {
      const p = this.player!.getPosition();
      if (p < 1) {
        // console.log('update: ' + p);
        this.bar.style.left = this.barWidth * p + 'px';
      } else {
        this.setState({ state: ViewState.Normal });
        return;
      }
    }

    this.updateRequest = requestAnimationFrame(this.update);
  };
  disposePlayer() {
    if (this.player) {
      this.player.dispose();
      this.player = null;
    }
    cancelAnimationFrame(this.updateRequest);
  }
  didClick = (e: React.MouseEvent<HTMLElement>) => {
    if (!canHover()) {
      if (this.player === null) {
        this.setState({ state: ViewState.Loading });
        this.playMusic();
      }
      return;
    }
    const { loop, onLabelSelect } = this.props;
    if (
      onLabelSelect &&
      (e.target as HTMLElement).nodeName.toLowerCase() === 'a' &&
      this.hasLabelDetails()
    ) {
      onLabelSelect(loop.label!);
    } else {
      this.select();
    }
  };

  select = () => {
    const { loop, onSelect } = this.props;
    window.removeEventListener('mousemove', this.onMouseMove);
    clearTimeout(this.playLoopTimeout);
    this.disposePlayer();
    onSelect(loop);
  };

  hasLabelDetails() {
    return this.props.loop.label?.thumbnail !== undefined;
  }
  render() {
    const { loop } = this.props;
    let labelName = loop.label?.name;
    if (labelName) {
      const labelParts = labelName.split(' ');
      const lastPart = labelParts[labelParts.length - 1].toLowerCase();
      if (['records', 'recordings'].indexOf(lastPart) > -1) {
        labelParts.pop();
        labelName = labelParts.join(' ');
      }
    }
    return (
      <div
        className={'loop-view loop-view--' + this.state.state}
        onClick={this.didClick}
        onMouseEnter={canHover() ? this.mouseDidEnter : undefined}
        onMouseLeave={this.mouseDidLeave}
      >
        <img
          src={loop.thumb}
          // crossOrigin="anonymous"
        />
        <div className="text">
          <div className="title" ref={this.contentEl}>
            <strong>{loop.name}</strong>
            {loop.version && <span> ({loop.version})</span>}
          </div>
          {loop.artist && <span>{loop.artist} - </span>}
          <a className={this.hasLabelDetails() ? '' : 'disabled'}>
            {labelName}
          </a>
          <div className="bar" />
        </div>
        {!canHover() && this.state.state !== ViewState.Normal && (
          <button className="medium primary select-btn" onClick={this.select}>
            Select
          </button>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/audio-editing/LoopOption.tsx